<template>
  <modal
    v-if="visible"
    :visible="visible"
    @click-outside-modal="$emit('close')"
  >
    <div
      class="flex justify-center px-4"
      style="minwidth: 80vw"
    >
      <div
        class="relative flex w-full flex-col items-start rounded bg-white p-8"
        :class="containerClass"
      >
        <img
          class="absolute right-4 top-4 h-4 w-4"
          src="@/assets/close-icon.svg"
          alt="close icon"
          @click="$emit('close')"
        />

        <div class="mb-6 mt-4 flex">
          <img
            class="mr-2"
            src="@/assets/yellow-checkmark.svg"
            alt="yellow checkmark"
          />
          <h3 class="text-3xl text-dark-blue">
            <slot />
          </h3>
        </div>

        <button-main @click="$emit('close')"> Continue </button-main>
      </div>
    </div>
  </modal>
</template>

<script>
import Modal from '@/components/modals/Modal.vue';
import ButtonMain from '@/components/Button.vue';

export default {
  name: 'SuccessModal',
  components: {
    Modal,
    ButtonMain,
  },
  props: {
    visible: Boolean,
    containerClass: String,
  },
  emits: ['close'],
  setup(_, { emit }) {
    const onCancel = () => {
      emit('close');
    };

    return {
      onCancel,
    };
  },
};
</script>
